import { useQuery } from '@tanstack/react-query';
import { GetBranchConfiguration, getBranchConfiguration } from '@/api/getBranchConfiguration';
import { queryKeys } from '@/constants/queryKeys';

interface Params<T> {
  brandId?: string;
  outletId?: string;
  select: (data: GetBranchConfiguration) => T;
}

export const useBranchConfiguration = <T>({ brandId, outletId, select }: Params<T>) => {
  return useQuery({
    queryKey: queryKeys.branchConfiguration({ brandId, outletId }),
    queryFn: () => {
      if (!brandId || !outletId) {
        throw new Error('Brand ID and outlet ID are required');
      }

      return getBranchConfiguration(brandId, outletId);
    },
    enabled: Boolean(brandId && outletId),
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 10,
    select,
  });
};
